import { BRAND } from "../config/brand";
import logo from "../assets/logo.png";
import "./brandMark.css";

export default function BrandMark({
  variant = "default",
  showTagline = true,
  logoOnly = false
}) {
  const hideText = logoOnly || variant === "sidebar" || variant === "hero";

  return (
    <div className={`brand-mark brand-mark--${variant}`}>
      <div className="brand-mark__logo-wrap">
        <img src={logo} alt={`${BRAND.name} logo`} className="brand-mark__logo" />
      </div>

      {!hideText && (
        <div className="brand-mark__text">
          <strong className="brand-mark__title">{BRAND.shortName}</strong>
          {showTagline && (
            <span className="brand-mark__tagline">{BRAND.productName}</span>
          )}
        </div>
      )}

      {variant === "sidebar" && showTagline && (
        <span className="brand-mark__sidebar-tagline">{BRAND.tagline}</span>
      )}
    </div>
  );
}
